import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import { RevisionCreateInput } from "types/generated";

import { COMMIT_SPACELIFT_VCS_FILES } from "./gql";

const useCommitSpaceliftVcsFilesMutation = createDefaultMutationHook(COMMIT_SPACELIFT_VCS_FILES);

const useCommitSpaceliftVcsFiles = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [mutation, { loading }] = useCommitSpaceliftVcsFilesMutation();

  const commitFiles = useCallback(
    (input: RevisionCreateInput, onSuccess?: (commitId: string) => void) => {
      mutation({ input }, (data) => {
        if (data?.revisionCreate) {
          reportSuccess({ message: "Commit created successfully" });
          onSuccess?.(data.revisionCreate.id);
        }
      });
    },
    [mutation, reportSuccess]
  );

  return {
    commitFiles,
    loading,
  };
};

export default useCommitSpaceliftVcsFiles;
